import { McpToolInput } from './mcp-tool-input'
import { McpToolOutput } from './mcp-tool-output'

export enum McpToolName {
  CreateContact = 'create_contact',
  GetContact = 'get_contact',
  UpdateContact = 'update_contact',
  GetContacts = 'get_contacts',
  RemoveContact = 'remove_contact',
  AssignContactTag = 'assign_contact_tag',
  RemoveContactTag = 'remove_contact_tag',
  GetContactFields = 'get_contact_fields',
  CreateTag = 'create_tag',
  GetTag = 'get_tag',
  GetTags = 'get_tags',
  UpdateTag = 'update_tag',
  RemoveTag = 'remove_tag',
  CreateAutomationRule = 'create_automation_rule',
  GetAutomationRule = 'get_automation_rule',
  GetAutomationRules = 'get_automation_rules',
  UpdateAutomationRule = 'update_automation_rule',
  DeleteAutomationRule = 'delete_automation_rule',
  CreateNewsletter = 'create_newsletter',
  GetNewsletter = 'get_newsletter',
  GetNewsletters = 'get_newsletters',
  UpdateNewsletter = 'update_newsletter',
  GetNewsletterIncludedTags = 'get_newsletter_included_tags',
  SetNewsletterIncludedTags = 'set_newsletter_included_tags',
  GetNewsletterExcludedTags = 'get_newsletter_excluded_tags',
  SetNewsletterExcludedTags = 'set_newsletter_excluded_tags',
  CreateCampaign = 'create_campaign',
  GetCampaign = 'get_campaign',
  GetCampaigns = 'get_campaigns',
  UpdateCampaign = 'update_campaign',
  DeleteCampaign = 'delete_campaign',
  CreateCampaignStep = 'create_campaign_step',
  GetCampaignStep = 'get_campaign_step',
  GetCampaignSteps = 'get_campaign_steps',
  UpdateCampaignStep = 'update_campaign_step',
  DeleteCampaignStep = 'delete_campaign_step',
  CreateFunnel = 'create_funnel',
  GetFunnel = 'get_funnel',
  GetFunnels = 'get_funnels',
  CreateFunnelStep = 'create_funnel_step',
  GetFunnelStep = 'get_funnel_step',
  GetFunnelSteps = 'get_funnel_steps',
  SaveContent = 'save_content',
  SaveFunnelPageContent = 'save_funnel_page_content',
  DescribeFunnels = 'describe_funnels',
  DescribeFunnelPageSchema = 'describe_funnel_page_schema',
  DescribePageContentGuide = 'describe_page_content_guide',
  DescribeMcpInstructions = 'describe_mcp_instructions',
  GetBookingCalendarEvents = 'get_booking_calendar_events',
  GetSmsTemplates = 'get_sms_templates',
  CreateCoupon = 'create_coupon',
  GetCoupon = 'get_coupon',
  GetCoupons = 'get_coupons',
  UpdateCoupon = 'update_coupon',
  DeleteCoupon = 'delete_coupon',
  CreatePricePlan = 'create_price_plan',
  GetPricePlan = 'get_price_plan',
  GetPricePlans = 'get_price_plans',
  UpdatePricePlan = 'update_price_plan',
  DeletePricePlan = 'delete_price_plan',
  CreateDigitalProduct = 'create_digital_product',
  GetDigitalProduct = 'get_digital_product',
  GetDigitalProducts = 'get_digital_products',
  UpdateDigitalProduct = 'update_digital_product',
  DeleteDigitalProduct = 'delete_digital_product',
}

export type McpTools = Record<
  McpToolName,
  {
    input: McpToolInput
    output: McpToolOutput
  }
>
